import request from '@/utils/request'
const dataObj = {
	version: '1.0',
	nonceStr: '1212fsadf',
	timestamp: '2020-4-21',
	signType: 'md5',
	content: { object: {} },
	sign: 'dafdsf'
}
// 枚举类
// 订单类型
export const orderType = data => {
	return request({
		url: '/api/v2/order/enums/type-list',
		method: 'post',
		data: { ...dataObj, content: data || undefined },
		mock: false
	})
}
// 订单状态
export const getOrderState = data => {
	return request({
		url: '/api/v2/order/enums/state-list',
		method: 'post',
		data: { ...dataObj, content: data || undefined },
		mock: false
	})
}
// 退单状态
export const chargeBackState = data => {
	return request({
		url: '/api/v2/order/enums/refund/state-list',
		method: 'post',
		data: { ...dataObj, content: data || undefined },
		mock: false
	})
}
// 菜品状态
export const dishState = data => {
	return request({
		url: '/api/v2/order/enums/dishes/state-list',
		method: 'post',
		data: { ...dataObj, content: data || undefined },
		mock: false
	})
}// 消费模式
export const consumState = data => {
	return request({
		url: '/api/v2/order/enums/consum/mode-list',
		method: 'post',
		data: { ...dataObj, content: data || undefined },
		mock: false
	})
}
// 核身方式
export const nuclearType = data => {
	return request({
		url: '/api/v2/order/enums/nuclear/mode-list',
		method: 'post',
		data: { ...dataObj, content: data || undefined },
		mock: false
	})
}
// 订单详情状态
export const orderDetailState = data => {
	return request({
		url: '/api/v2/order/enums/detail/state-list',
		method: 'post',
		data: { ...dataObj, content: data || undefined },
		mock: false
	})
}
// 订单详情类型
export const orderDetailType = data => {
	return request({
		url: '/api/v2/order/enums/detail/type-list',
		method: 'post',
		data: { ...dataObj, content: data || undefined },
		mock: false
	})
}
// 审核状态
export const orderCheckType = data => {
	return request({
		url: '/api/v2/order/enums/check/state-list',
		method: 'post',
		data: { ...dataObj, content: data || undefined },
		mock: false
	})
}
// 配送方式
export const deliveryType = data => {
	return request({
		url: '/api/v2/alloc/canteen/list-delivery-type-enum',
		method: 'post',
		data: { ...dataObj, content: data || undefined },
		mock: false
	})
}
// 配送状态
export const deliveryState = data => {
	return request({
		url: '/api/v2/order/enums/delivery/state-list',
		method: 'post',
		data: { ...dataObj, content: data || undefined },
		mock: false
	})
}
// 来源类型
export const sourceType = data => {
	return request({
		url: '/api/v2/order/enums/source/type-list',
		method: 'post',
		data: { ...dataObj, content: data || undefined },
		mock: false
	})
}
// 支付方式
export const payType = data => {
	return request({
		url: '/api/v2/pay/all/type',
		method: 'post',
		data: { ...dataObj, content: data || undefined },
		mock: false
	})
}
// 获取食堂
export const canteenList = data => {
	return request({
		url: '/api/v2/alloc/canteen/list-all-auth-canteen',
		method: 'post',
		data: { ...dataObj, content: data || undefined },
		mock: false
	})
}
export const canteenListHalf = data => {
	return request({
		url: '/api/v2/alloc/canteen/list-all-auth-half-canteen',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}
// 根据食堂id获取档口列表
export const stallList = data => {
	return request({
		url: '/api/v2/alloc/canteen/list-auth-stall',
		method: 'post',
		data: { ...dataObj, content: data || undefined },
		mock: false
	})
}
